import { Switch, SwitchProps } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

function SwitchComponent({ type, size, label, ...rest }: SwitchProps & { label: string | React.ReactNode }) {
  return <FormControlLabel labelPlacement='start' sx={{ ml: 1 }} control={<Switch {...rest} />} label={label} />;
}

export default SwitchComponent;
